<template>
  <div class="year-select">
    <a-popover v-model="visible" trigger="click">
      <div slot="content">
        <a-radio-group v-model="year" @change="onChange">
          <a-radio-button v-for="(item,index) in years" :key="index" :value="item">
            {{ item }}
          </a-radio-button>

        </a-radio-group>
      </div>
      <a-input class="tc" v-model="year" placeholder="请选择年份" read-only>
        <a slot="prefix" class="gray-light" href="javascript:;" @click.stop="pre"> <a-icon type="left" /></a>
        <a slot="suffix" class="gray-light" href="javascript:;" @click.stop="next" :class="{disabled:this.year===this.currentYear}"> <a-icon type="right" /></a>
      </a-input>
    </a-popover>

  </div>
</template>
<script>

export default {
  props: {
    value: {
      type: [String, Number],
      default: 2020
    }
  },
  data () {
    return {
      year: '',
      currentYear: '',
      visible: false,
      years: []
    }
  },
  watch: {
    year (newVal, oldVal) {
      this.$emit('input', newVal)
    },
    value (newVal, oldVal) {
      this.year = newVal
    }
  },
  mounted () {
    this.$nextTick(res => {
      const date = new Date()
      this.currentYear = date.getFullYear()
      this.year = date.getFullYear()
      for (let i = 0; i < 6; i++) {
        const year = this.currentYear - i
        this.years.push(year)
      }
    })
  },
  methods: {
    pre () {
      this.year--
      this.visible = false
    },
    next () {
      if (this.year === this.currentYear) {
        return
      }
      this.year++
      this.visible = false
    },
    onChange () {}
  }
}
</script>
<style lang="less">
.tc{
  .ant-input{
    text-align: center;
  }
}
</style>
<style lang="less" scoped>
@import '../../styles/var.less';
.disabled{
  color:@disabled-text-color;
  cursor: not-allowed;
}
.ant-radio-group{
  width: 200px;
}
.ant-radio-button-wrapper{
  color: @text-color-lightgray;
  border: none;
}
.ant-radio-button-wrapper:not(:first-child)::before{
  background-color: @white !important;
}
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled){
  border-radius: 4px;
  background-color:@main-color;
  color: @white;
  box-shadow: none;
}
</style>
